import { BackButtonContext } from 'contexts/BackButtonContext';
import { AnimateSharedLayout } from 'framer-motion';
import React, { useContext, useEffect } from 'react';

import { PageWrapper } from '../PageWrapper';
import { BlankPageProps } from './types';
import { useCloseAppDrawerOnNavigation } from 'kineticUtils/hooks';

const BlankPage: React.FunctionComponent<BlankPageProps> = (props) => {
  const { children, reference } = props;

  const { setBackButton } = useContext(BackButtonContext);
  useCloseAppDrawerOnNavigation();

  useEffect(() => {
    setBackButton();
  }, [setBackButton]);

  const renderBlankPage = () => {
    return (
      <AnimateSharedLayout>
        <PageWrapper reference={reference}>{children}</PageWrapper>
      </AnimateSharedLayout>
    );
  };

  return renderBlankPage();
};

export default BlankPage;
